<template>
  <el-card>
    <iframe
      width="100%"
      height="515"
      src="https://www.youtube.com/embed/fdwlHk4QrC8"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </el-card>
</template>

<script>
// test
//import ComponentInWorker from "@/components/ComponentInWorker";
export default {
  name: "trainingMview"
  // components: {
  //   ComponentInWorker
  // }
};
</script>

<style></style>
